import React, { useEffect, useState } from "react";
import { withRouter } from "react-router-dom";
import "./template-task-creation.scss";
import TemplateTaskCreationTopNew from "./template-task-creation-top-new";
import TemplateTaskCreationPanelFormNew from "./template-task-creation-form-new";
import { getTaskTypes } from "../../../../../services/api/task-types-api";
import { GetTemplateTaskAPI } from "../../../../../services/api/project-template-api";
import { taskInitialize } from "../template-task-utility";

const TemplateTaskCreationPanelNew = (props) => {
  const isCreate = props.location.pathname.includes("/templates/tasks/create");
  const isEdit =
    props.location.pathname.includes("/templates/tasks/edit") ||
    props.location.pathname.includes("/templates/tasks/view");
  let isView = props.location.pathname.includes("/tasks/view");
  let isSubtask = props.location.pathname.includes("/subtasks");
  const templateName = props.location.state
    ? props.location.state.templateName
    : "";
  const taskId = parseInt(props.location.pathname.split("/")[5]);
  const templateId = props.location.state ? props.location.state.templateID : 0;

  const [task, setTask] = useState({ ...taskInitialize });

  const [taskTypes, setTaskTypes] = useState({
    data: [],
    isLoading: true,
  });

  const [alertConfig, setAlertConfig] = useState({
    showAlert: false,
    alertAction: "",
    alertMessage: "",
    alertVariant: "danger",
  });
  const [panelVisibility, setPanelVisibility] = useState({
    showCancelPanel: false,
    showConfirmPanel: false,
    showCreatePanel: false,
  });

  useEffect(() => {
    if (!taskTypes.isLoading && isEdit) {
      LoadTask();
    } else if (taskTypes.isLoading) {
      LoadTaskTypes();
    }
  }, [taskTypes.isLoading]);

  const LoadTaskTypes = async () => {
    try {
      let result = await getTaskTypes();
      let modifiedResult = result.map((type) => {
        return { id: type.Id, name: type.Type };
      });
      setTaskTypes((prev) => ({
        data: [...prev.data, ...modifiedResult],
        isLoading: false,
      }));
    } catch (error) {
      setAlertConfig((prevState) => ({
        ...prevState,
        showAlert: true,
        alertMessage: error.toString(),
      }));
    }
  };

  const LoadTask = async () => {
    try {
      let result = await GetTemplateTaskAPI(taskId);
      if (result?.response?.status === 200 || result?.status === 200) {
        setTask((prev) => ({
          data: { ...prev.data, ...result.data },
          isLoading: false,
        }));
      } else {
        throw new Error(result.response.data);
      }
    } catch (error) {
      setAlertConfig((prevState) => ({
        ...prevState,
        showAlert: true,
        alertMessage: error.toString(),
      }));
    }
  };

  const AddAnotherTask = () => {
    setTask((prev) => ({ ...prev, ...taskInitialize }));
    setPanelVisibility((prev) => ({
      ...prev,
      showCreatePanel: false,
    }));
  };

  return (
    <React.Fragment>
      <TemplateTaskCreationTopNew
        isEdit={isEdit}
        templateName={templateName}
        templateId={templateId}
        isSubtask={isSubtask}
        alertConfig={alertConfig}
        setAlertConfig={setAlertConfig}
        isView={isView}
        panelVisibility={panelVisibility}
        setPanelVisibility={setPanelVisibility}
        AddAnotherTask={AddAnotherTask}
      />
      <TemplateTaskCreationPanelFormNew
        isCreate={isCreate}
        isSubtask={isSubtask}
        taskTypes={taskTypes.data}
        task={task.data}
        setAlertConfig={setAlertConfig}
        isView={isView}
        isEdit={isEdit}
        templateId={templateId}
        templateName={templateName}
        setPanelVisibility={setPanelVisibility}
      />
    </React.Fragment>
  );
};

export default withRouter(TemplateTaskCreationPanelNew);
